import { MapModule as MapModuleOl } from './MapModuleClass.ol';

/**
 * @class Oskari.mapframework.ui.module.common.MapModule
 *
 * Provides map functionality/Wraps actual map implementation (Openlayers).
 * Currently hardcoded at 13 zoomlevels (0-12) and SRS projection code 'EPSG:3067'.
 * There are plans to make these more configurable in the future.
 *
 * See http://www.oskari.org/trac/wiki/DocumentationBundleMapmodule
 */
Oskari.clazz.defineES('Oskari.mapframework.ui.module.common.MapModule', MapModuleOl, {
  /**
   * @property {String[]} protocol
   * @static
   */
  'protocol': ['Oskari.mapframework.module.Module']
});